import Offers from "./Offers";
import Countries from "./Countries";
import Percentage from "./Percentage";

export default { Offers, Countries, Percentage };


// WEBPACK FOOTER //
// ./src/services/API/components/Dating/index.js